import AppCatalog from "../../../services/App/AppCatalog.js";
import Catalog from "../CliCatalog.js";
import ClientAddressCatalog from "../CliaCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: AppCatalog.Field.Search.Label + " " +
      Catalog.Name.Label + ", atau " +
      Catalog.Alias.Label + ", atau " +
      ClientAddressCatalog.Address.Label + ", atau " +
      ClientAddressCatalog.ContactMobile.Label + ", atau " +
      ClientAddressCatalog.ContactPhone.Label + ", atau " +
      ClientAddressCatalog.ContactEmail.Label,
    Type: AppCatalog.Field.Search.Type,
    MaxLength: AppCatalog.Field.Search.MaxLength
  }
}